<p>
  cruise-criteria works!
</p>
